import React from 'react'
import LocalePt from '../../flexmonster/locale/pt.json'
import { DataUtilsService } from '../../services/DataUtilsService'
import * as FlexmonsterReact from 'react-flexmonster'
import SelectTheme from './SelectTheme';


import {    
  Link,    
  withRouter,  
} from "react-router-dom";

//layout
import {withStyles} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid'
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import SaveIcon from '@material-ui/icons/Save'
import IconButton from '@material-ui/core/IconButton'
import Breadcrumbs from '@material-ui/core/Breadcrumbs'
import Home from '@material-ui/icons/Home'
import FormGroup from '@material-ui/core/FormGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import AlertGeneral from '../../component/AlertGeneral/AlertGeneral'

//formularios
import Select from '@material-ui/core/Select'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Chip from '@material-ui/core/Chip'
import TextField from '@material-ui/core/TextField'
import TextareaAutosize from '@material-ui/core/TextareaAutosize'
import Button from '@material-ui/core/Button'
import Autocomplete from '@material-ui/lab/Autocomplete'

//servicos
import CompanyService from '../../services/CompanyService'
import UserService from '../../services/UserService'
import QueryCrmService from '../../services/QueryCrmService'
import ConnectionService from '../../services/ConnectionsService'
import DatasetDynamicService from '../../services/DatasetDynamicService'

//componentes de graficos
import ChartManager from '../../component/Charts/ChartManager'


const useStyles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: 20,
    marginBottom: 400,
  },
  paper: {
    padding: theme.spacing(2),      
    color: theme.palette.text.secondary,    
  },    
  formControl: {
    margin: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
  },
  textArea: {
    width: '100%',
  },
});

class DatasetAddv2 extends React.Component {

  constructor(props){
    super(props);         
    this.refFlexmonster = React.createRef();

    this.state = {
      id: this.props.match.params.id,    
      alerts: {
        open: false,
        severity: "success",
        msg: 'Dataset salvo com sucesso!'
      },
      description: '', 
      companies: [],
      companiesSelected: [],
      users: [],
      isUseCache: false,
      isShowDashboard: false,
      isShowMenu: false,
      enable: false,
      usersSelected: [],
      loadingCompany: false,
      connectors: [],
      connector: {},
      chartType: "",
      chartOption: {},
      managerOptions: [],
      out: "",     
      data: {},
      resultDatasetQuery: [],
      query: '',    
      order: 0,
      spaceWidth: 4,
      spaceHeight: 400,               
      scheduler:{
        sun: false,
        mon: false,
        tue: false,
        wen: false,
        thu: false,
        fri: false,
        sat: false,
        time:''
      },
      chartConfig: {
        chartType: '',
        option:{},
      },
    }    
  }

  schedulerDefault = () => {
    return {
      sun: false,
      mon: false,
      tue: false,
      wen: false,
      thu: false,
      fri: false,
      sat: false,
      time:''
    }
  }

  componentDidMount(prevProps) {        
      this.loadingAll()
  }

  componentDidUpdate(prevProps) {
    if(this.props.match.params.id !== prevProps.match.params.id) {
      this.loadingAll()
    }
  }

  loadingAll = () => {
    const response = ConnectionService.connectionSearch()
    response
    .then( resp => {
      this.setState({connectors: resp.data})
    })
    .then( resp => {      
      if(!this.props.match.params.id) return

      const respDynData = DatasetDynamicService.fetchFullById(this.props.match.params.id)
      respDynData.then((respDy)=>{          
          const data = respDy.data;       
          
          this.setState({
            out: data.out,
            description: data.description,
            connector: data.connector ? data.connector.id:'',
            query: data.query,
            companiesSelected: data.companies,
            usersSelected: data.users,                
            isShowDashboard: data.isShowDashboard,        
            order: data.order,        
            isShowMenu: data.isShowMenu,
            isUseCache: data.isUseCache,
            spaceWidth: data.spaceWidth,        
            spaceHeight: data.spaceHeight,        
            scheduler: data.scheduler ? JSON.parse(data.scheduler) : this.schedulerDefault(),        
            enable: data.enable,     
            chartType: data.chartType,                    
            managerOptions: this.parseToObjectWhile(data.managerOptions),                    
            report: data.report?JSON.parse(data.report):{},
            chartOption:data.report?this.parseToObjectWhile(data.report):{},
          })          
          this.searchUsersByCompany(data.companies)   
          this.loadingOut(data)                         
      })
    })
    .catch(error => console.error(error))
  }

  parseToObjectWhile = (item) => {
    while(typeof item === "string"){
      item = JSON.parse(item);      
    }
    return item;
 
  }

  loadingOut = (data) => {
      
    if(!data.query || data.query.length < 1){
      return
    }

    const response = QueryCrmService.execute({
      query: data.query,
      connectorId: this.state.connector 
    })
    response
    .then( (resp) => {      
      const lines = resp.data.split("\n");
      const dataset = [];
      lines.forEach( line => {
        if(line) 
          dataset.push(JSON.parse(line))
      })

      this.setState({resultDatasetQuery: dataset})
      
      if(this.state.out === "flexmonster"){
        if(data.report){
          let flexReport = JSON.parse(data.report)

          flexReport.dataSource.data = dataset

          let keys = Object.keys(dataset[0])
          let mapping = {}

          let re = /cpf|cnpj/i

          keys.forEach((key) => {
            if(re.test(key))
              mapping[key] = {
                "type": "string"
              }
          })

          if(Object.keys(mapping).length !== 0)
            flexReport.dataSource.mapping = mapping

          this.refFlexmonster.current.flexmonster.setReport(flexReport)

        } else if( dataset.length > 0){
          this.refFlexmonster.current.flexmonster.setReport({
            dataSource:{
              data: dataset
            }
          })
        }
      } else if(this.state.out === "chartsHighcharts"){             
        // this.setState({chartOption: JSON.parse(data.report)})                                            
      }
      
    })
    .catch(err => {
      console.error(err)
    })       
}

  save = () => {

    const {history} = this.props
    let connectorSelectedForm = null
    const connectorSelected = 
      this.state.connectors.find((item) => {
        if(item.id === this.state.connector)
          return item
      })
    if(connectorSelected){
      connectorSelectedForm = {
        id: connectorSelected.id,
        label: connectorSelected.description,
      }                                                      
    }                  

    let reportWithoutData = null

    if(this.state.out === "flexmonster"){
      reportWithoutData = this.refFlexmonster.current.flexmonster.getReport()
    
      if(reportWithoutData && reportWithoutData.dataSource){
        reportWithoutData.dataSource.data = []
      }
    } else if(this.state.out === "chartsHighcharts" ){

      if(this.state.chartOption){
        let newOptions = {}                  
        Object.assign(newOptions, this.state.chartOption)
        if(newOptions.series){
          newOptions.series.map(serie=> {
            serie.data = []
          })
          if(!newOptions.title){
            newOptions.title = {
              text: " "
            }
          } else {
            newOptions.title.text = " " 
          }     
          
          reportWithoutData = newOptions
        }
      }
    }

    const response = DatasetDynamicService.save({
      id: this.state.id,
      description: this.state.description,
      query: this.state.query,        
      out: this.state.out,
      connector: connectorSelectedForm,
      companies: this.state.companiesSelected.map( (item) => { return {id: item.id, label: item.label}}),
      users: this.state.usersSelected.map( (item) => { return {id: item.id, label: item.label}}),                        
      isUseCache: this.state.isUseCache,        
      isShowDashboard: this.state.isShowDashboard,        
      isShowMenu: this.state.isShowMenu,        
      spaceWidth: this.state.spaceWidth,        
      spaceHeight: this.state.spaceHeight,        
      scheduler: JSON.stringify(this.state.scheduler),        
      report: JSON.stringify(reportWithoutData),        
      order: this.state.order,   
      enable: this.state.enable,     
      chartType: this.state.chartType,     
      managerOptions: JSON.stringify(this.state.managerOptions),
    })
      response
        .then(resp => {                                                        
          if(!this.props.match.params.id)
            history.push(`add/${resp.data.id}`)  

            this.setState({
              alerts: {
                open: true,
                severity: "success",
                msg: 'Dataset foi salvo com sucesso!'
              }
            })
            
        })
        .catch(error => {
          if(error?.response?.status === 400){
            this.setState({
              alerts: {
                open: true,
                severity: "error",
                msg: error?.response?.data,
              }
            })
          }
          console.error(error)
        })                                                
  }

  handleCloseAlert = () => {
    this.setState({
      alerts: {
        open: false,
        severity: "success",
        msg: 'Dataset foi salvo com sucesso!'
      }
    })
  }

  searchUsersByCompany = (param) => {
  
    const ids = param.map(item => item.id);

    if(!ids || ids.length < 1 ) return

    const userResponse = UserService.user(ids)

    userResponse
      .then( resp => {                    
        this.setState({users: resp.data})  
      })
      .catch(err => {
        console.error(err)
      })
  }
  
  searchCompanyByTerm = (term) => {    

    if(!term || term.length < 2) return 

    this.setState({loadingCompany:true})
    const companiesResponse = CompanyService.companies(term)
    companiesResponse
      .then(resp => {                
        this.setState({
          companies:resp.data, 
          loadingCompany:false
        })        
      })
      .catch(err => {
        this.setState({loadingCompany:false})
        console.error(err)
      })    
  }

  executeTestQuery = () =>{    
    
    const response = QueryCrmService.execute({
      query: this.state.query,
      connectorId: this.state.connector
    })

    response
      .then( (resp) => {
        const dataset = DataUtilsService.getObjectByAnything(resp.data)
        const repor = {
          "dataSource": {
              "dataSourceType": "json",
              "data": dataset,
          },       
          localization: LocalePt,                  
        }                

        this.setState({resultDatasetQuery: dataset})
        
        if(this.refFlexmonster && this.refFlexmonster.current)
          this.refFlexmonster.current.flexmonster.setReport(repor)
        
      })
      .catch(err => {
        console.error(err)
      })    
  }

  handlerDescription = (event) => {
    this.setState({description: event.target.value})      
  }

  handleCompanySelectItem = (option, param) => {    
    this.setState({companiesSelected: param})    
    this.searchUsersByCompany(param)    
  }

  handleSearchCompanyDefault = () => {                  
    this.searchCompanyByTerm('ads')  
  }

  handleCompany = (event) => {                  
    this.searchCompanyByTerm(event.target.value.trim())  
  }

  handlerUserslectItem = (option, param) => {         
    this.setState({usersSelected:param})    
  }

  handlerConnector = (event) => {             
    this.setState({connector: event.target.value})
  }
  handlerOut = (event) => {        
    this.setState({
      out: event.target.value,
      chartType: "",       
    });   
         
  }
  handlerQuery = (event) => {    
    this.setState({query: event.target.value})
  }

  handleEnable = (event) => {
    this.setState({enable: event.target.checked})
  }

  handleShowDashboard = (event) => {
    this.setState({isShowDashboard: event.target.checked})
  }
  handleCache = (event) => {
    this.setState({isUseCache: event.target.checked})
  }
  
  handleShowMenu = (event) => {
    this.setState({isShowMenu: event.target.checked})
  }
  

  handleTab = (event, newValue) => {
    this.setState({tab: newValue})
  } 
  
  handleSun = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, sun: event.target.checked}});    
  }

  handleMon = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, mon: event.target.checked}});    
  }
  
  handleTue = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, tue: event.target.checked}});    
  }
  
  handleWen = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, wen: event.target.checked}});    
  }
  
  handleThu = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, thu: event.target.checked}});    
  }
  
  handleFri = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, fri: event.target.checked}})
  }

  handleSat = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, sat: event.target.checked}})
  }

  handleTime = (event) => {            
    this.setState({ scheduler: {...this.state.scheduler, time: event.target.value}})
  }

  handleSpaceWidth = (event) => {
    this.setState({ spaceWidth: event.target.value});   
  }

  handleSpaceHeight = (event) => {
    this.setState({ spaceHeight: event.target.value});   
  }

  handleOrder = (event) => {
    this.setState({ order: event.target.value});   
  }

  handleSelectChartType = (event) => {    
    this.setState({chartType: event.target.value})
  } 

  handleChartOption = (option) => {            
    this.setState({chartOption: option}) 
  }

  handleManagerOptions = (managerOptions) => {        
    this.setState({managerOptions: managerOptions})
  }

  render(){

    const { classes } = this.props;

    return(
      <Grid container  className={classes.root} spacing={2}>


        <AlertGeneral status={this.state.alerts} onEventClose={this.handleCloseAlert} />

        <Grid item xs={12} >
          <Breadcrumbs aria-label="breadcrumb">
            <Link color="inherit" to="/"  >
              <Home/>
            </Link>
            <Link color="inherit" to="/dataset" >
              Datasets
            </Link>
            <Typography color="textPrimary">{this.state.description}</Typography>
          </Breadcrumbs>
        </Grid>
  
        <Grid item xs={12} >
            <Paper className={classes.paper} >                            
              <IconButton color="primary" onClick={this.save}  ><SaveIcon /></IconButton>                                                        
            </Paper>
        </Grid>

      
        <Grid  className={classes.root}>

          <Paper className={classes.paper} >  

            <Grid item xs={12} className={classes.formControl} >
              <TextField               
                label="Descrição"
                fullWidth                    
                value={this.state.description}
                onChange={this.handlerDescription}
                InputLabelProps={{
                  shrink: true,
                }}         
              />
            </Grid>

            <Grid item xs={12} className={classes.formControl} >
                <Autocomplete     
                  value={this.state.companiesSelected}                     
                  onChange={this.handleCompanySelectItem}   
                  onKeyUp={this.handleCompany}      
                  multiple
                  filterSelectedOptions                
                  options={this.state.companies}        
                  getOptionLabel={(option) => {                                    
                    return option.id +" - " + option.label;
                  }}       
                  getOptionSelected={(option, value) => option.label === value.label}    
                  renderOption={(option) => {                                    
                    return `${option.id} | ${option.label} | ${option.identifier ? `cnpj ${option.identifier}`:''}`
                  }}   
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip                                  
                          color="primary" 
                          label={option.id + ' ' + option.label} 
                          {...getTagProps({ index })} 
                          />
                    ))
                  } 
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      onClick={this.handleSearchCompanyDefault}
                      variant="standard"
                      label="Empresas"
                      placeholder="Selecione"
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} className={classes.formControl} >
                <Autocomplete
                  multiple
                  value={this.state.usersSelected}
                  filterSelectedOptions            
                  options={this.state.users}
                  getOptionLabel={(option) => option.username}  
                  getOptionSelected={(option, value) => option.username === value.username}    
                  onChange={this.handlerUserslectItem}
                  renderOption={(option) => {                                    
                    return `${option.id} | ${option.label} | ${option.username}`
                  }}
                  renderTags={(value, getTagProps) =>
                    value.map((option, index) => (
                      <Chip color="primary" label={option.label} {...getTagProps({ index })} />
                    ))
                  }              
                  renderInput={(params) => (
                    <TextField
                      label="Usuários"
                      {...params}
                      variant="standard"                    
                    />
                  )}
                /> 
              </Grid>

              <Grid container  >
                <Grid item xs={12}  md={3} className={classes.formControl} >                
                  <InputLabel htmlFor="connectors">Conector</InputLabel>
                  <Select              
                      labelId="connectors"
                      fullWidth 
                      value={this.state.connector}    
                      onChange={this.handlerConnector}                                            
                    >                        
                      {this.state.connectors.map((item) => {
                        return <MenuItem key={item.id} value={item.id} >{item.description}</MenuItem>              
                      })}           
                    </Select>                  
                </Grid>

                <Grid item xs={12} md={3} className={classes.formControl} >                
                  <InputLabel htmlFor="fonte-dados">Saida</InputLabel>
                  <Select              
                      labelId="fonte-dados"
                      fullWidth
                      value={this.state.out}
                      onChange={this.handlerOut}                        
                    >
                      <MenuItem value="" >Selecione</MenuItem>                                      
                      <MenuItem value={"flexmonster"} >Pivot (Flexmonster)</MenuItem>                                      
                      <MenuItem value={"chartsHighcharts"} >Graficos (Highcharts)</MenuItem>                                      
                    </Select>                
                </Grid>     

                <Grid item xs={12} md={3} className={classes.formControl} >                        
                  <InputLabel htmlFor="fonte-dados">Espaço que ocupa no dashboard</InputLabel>
                  <Select              
                      labelId="fonte-dados"
                      fullWidth   
                      value={this.state.spaceWidth}
                      onChange={this.handleSpaceWidth}
                    >
                      <MenuItem value={4} >1/3 da tela (Padrão)</MenuItem>
                      <MenuItem value={6} >1/2 - Metade da Tela</MenuItem>
                      <MenuItem value={12} >Tela Inteira</MenuItem>
                    </Select>   
                </Grid>              
                <Grid item xs={12} md={3} className={classes.formControl} >                
                  <TextField     
                      type="number"          
                      label="Altura"
                      fullWidth
                      value={this.state.spaceHeight}    
                      onChange={this.handleSpaceHeight}                                                               
                      InputLabelProps={{
                        shrink: true,
                      }}         
                  />                                                   
                </Grid>  

                <Grid item xs={12} md={3} className={classes.formControl} >                
                  <TextField     
                      type="number"          
                      label="Ordem"
                      fullWidth
                      value={this.state.order}    
                      onChange={this.handleOrder}                                                               
                      InputLabelProps={{
                        shrink: true,
                      }}         
                  />   
                </Grid> 

                <Grid item xs={12} className={classes.formControl} >    
                  <FormGroup row>

                    <FormControlLabel                      
                      control={<Switch checked={this.state.enable} onChange={this.handleEnable} />}
                      label="Ativo"
                    />
                    
                    <FormControlLabel                      
                      control={<Switch checked={this.state.isShowDashboard} onChange={this.handleShowDashboard} />}
                      label="Mostrar No DashBoard"
                    />            

                    <FormControlLabel                      
                      control={<Switch checked={this.state.isShowMenu} onChange={this.handleShowMenu} />}
                      label="Mostrar No Menu"
                    />       

                    <FormControlLabel                      
                      control={<Switch checked={this.state.isUseCache} onChange={this.handleCache} />}
                      label="Habilitar Cache"
                    />     


                  </FormGroup>           
                </Grid> 
                
                {/*<Grid item xs={12} className={classes.formControl} >    */}
                {/*  <h2>Agendar - Envio de email</h2>*/}
                {/*      */}
                {/*  <FormGroup row >*/}
                {/*    <FormControlLabel*/}
                {/*      control={<Checkbox />}                                            */}
                {/*      checked={this.state.scheduler.sun}*/}
                {/*      onChange={this.handleSun}*/}
                {/*      label="Dom"*/}
                {/*    />*/}

                {/*    <FormControlLabel*/}
                {/*      control={<Checkbox />}*/}
                {/*      checked={this.state.scheduler.mon}*/}
                {/*      onChange={this.handleMon}*/}
                {/*      label="Seg"*/}
                {/*    />*/}
                {/*    <FormControlLabel*/}
                {/*      control={<Checkbox />}*/}
                {/*      checked={this.state.scheduler.tue}*/}
                {/*      onChange={this.handleTue}*/}
                {/*      label="Ter"*/}
                {/*    />*/}
                {/*    <FormControlLabel*/}
                {/*      control={<Checkbox  />}*/}
                {/*      checked={this.state.wen}*/}
                {/*      onChange={this.handleWenn}*/}
                {/*      label="Qua"*/}
                {/*    />*/}
                {/*    <FormControlLabel*/}
                {/*      control={<Checkbox />}*/}
                {/*      checked={this.state.scheduler.thu}*/}
                {/*      onChange={this.handleThu}*/}
                {/*      label="Qui"*/}
                {/*    />*/}
                {/*    <FormControlLabel*/}
                {/*      control={<Checkbox />}*/}
                {/*      checked={this.state.scheduler.fri}*/}
                {/*      onChange={this.handleFri}*/}
                {/*      label="Sex"*/}
                {/*    />*/}
                {/*    <FormControlLabel*/}
                {/*      control={<Checkbox />}*/}
                {/*      checked={this.state.scheduler.sat}*/}
                {/*      onChange={this.handleSat}*/}
                {/*      label="Sab"*/}
                {/*    />  */}
                {/*    */}
                {/*  </FormGroup>                                                                                                       */}
                {/*</Grid>  */}

                {/*<Grid item xs={4} className={classes.formControl} >*/}
                {/*  <TextField     */}
                {/*    type="time"   */}
                {/*    fullWidth       */}
                {/*    label="Horário de envio"  */}
                {/*    value={this.state.scheduler.time}                                */}
                {/*    onChange={this.handleTime}*/}
                {/*    InputLabelProps={{*/}
                {/*      shrink: true,*/}
                {/*    }}  */}
                {/*  />   */}
                {/*</Grid>  */}
                           
              </Grid>      
              

              <Grid item xs={12} >

                                         
                  <h2>Definir Consulta</h2>       

                  <TextareaAutosize            
                      rowsMin={10}
                      className={classes.textArea}
                      placeholder="Query (SQL)"
                      label="Query (SQL)"
                      value={this.state.query}
                      onChange={this.handlerQuery}
                  /> 

                  <Button 
                      variant="contained" 
                      color="primary"   
                      onClick={this.executeTestQuery}                                              
                  > 
                    Execute Query
                  </Button>

                  
                  {this.state.out === "flexmonster"?(
                      <>
                         <SelectTheme/>

                     <FlexmonsterReact.Pivot   
                      ref={this.refFlexmonster}
                      toolbar={true}        
                      licenseKey={process.env.REACT_APP_FLEXMONSTER_KEY}
                      width="100%"    
                      height={700}      
                    /></>)
                    : this.state.out === 'chartsHighcharts' ? (
                      <ChartManager 
                          chartType={this.state.chartType}        
                          managerOptions={this.state.managerOptions}                   
                          report={this.state.report}
                          dataset={this.state.resultDatasetQuery}                                                     
                          onEnvetManagerOptions={this.handleManagerOptions} 
                          onEventChangeChartType={this.handleSelectChartType}
                          onEventOption={this.handleChartOption}
                      />
                    ) : ''
                    
                  } 
                  
                                
            </Grid>            
          </Paper>
        </Grid>
      </Grid>
      
    )
  }
}

export default withStyles(useStyles)(withRouter(DatasetAddv2))
